import { ENVIROMENT } from '../../src/components/customUtils/AppConstants'
const CONFIG_IP_LOCAL = 'localhost'
const CONFIG_IP_LOCAL_M = '192.168.0.6' // 🔧 IP de tu Mac en la red local para desarrollo en dispositivo

export const CONFIG_IP_TEST = '34.207.229.228'

const RELEASE = 'v2'
export const TEST = 'testing'

export const VERSION_DATABASE = 60 //Si se sube la version, descomentar tablas sensibles de indexDB

// ⚡ PERFORMANCE MONITOR - Activar/Desactivar sistema de monitoreo
// true = Activo (para testing/development)
// false = Desactivado (para producción final)
export const PERFORMANCE_MONITOR_ENABLED = false

export const apiUrl = `https://${RELEASE}-${ENVIROMENT}.1onesolutions.com`
// export const apiUrl = `https://${TEST}-${ENVIROMENT}.1onesolutions.com`
// 🔧 Para IPA de desarrollo en dispositivo real, usa CONFIG_IP_LOCAL_M
// 🔧 Para simulador o web, usa CONFIG_IP_LOCAL
// export const apiUrl = `http://${CONFIG_IP_LOCAL}:3002`

export const apiUrlWSocket = 'wss://18.189.12.199:8089'
export const baseURLWSocket =
    'wss://riblupfc1e.execute-api.us-east-1.amazonaws.com/production'

export const HARDCODE_DOTI = false
